module.exports = __webpack_public_path__ + "media/img/corporate/logos/credit_suisse-d4246d0b4b9c8df3ce2bec477902cafd.svg";